if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        const toggleZoom = (event) => {
          const image = event.target;
          if (!window.matchMedia("(max-width: 749px)").matches || !(image instanceof HTMLImageElement) || !image.closest(".product-media-modal__content")) return;
          if (event.type === "keydown" && event.key !== "Enter" && event.key !== " ") return;
          event.preventDefault();
          const zoomed = image.classList.toggle("jungle-media-zoomed");
          image.setAttribute("aria-pressed", String(zoomed));
        };
        this.addEventListener("pointerup", (event) => {
          if (window.matchMedia("(max-width: 749px)").matches && event.target instanceof HTMLImageElement && event.target.closest(".product-media-modal__content")) event.stopImmediatePropagation();
        }, true);
        this.addEventListener("click", toggleZoom);
        this.addEventListener("keydown", toggleZoom);
      }

      hide() {
        this.resetMobileZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      resetMobileZoom() {
        this.querySelectorAll(".jungle-media-zoomed").forEach((image) => {
          image.classList.remove("jungle-media-zoomed");
          image.setAttribute("aria-pressed", "false");
        });
      }

      showActiveMedia() {
        this.resetMobileZoom();
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        if (activeMedia instanceof HTMLImageElement && window.matchMedia('(max-width: 749px)').matches) {
          activeMedia.setAttribute('role', 'button');
          activeMedia.setAttribute('tabindex', '0');
          activeMedia.setAttribute('aria-pressed', 'false');
        }
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
